(() => {
  if (customElements.get('rm-community-reviews')) return;

  class RMCommunityReviews extends HTMLElement {
    #controller;
    #trigger;
    #dialog;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      this.#dialog = this.querySelector('dialog');
      if (!this.#dialog) return;
      const options = { signal: this.#controller.signal };

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-review-open]');
        if (trigger) this.#openReview(trigger);
        if (event.target.closest('[data-review-close]')) this.#dialog.close();
        if (event.target === this.#dialog) {
          const rect = this.#dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.#dialog.close();
          }
        }
      }, options);

      this.#dialog.addEventListener('close', () => this.#trigger?.focus(), options);
      this.#dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = [...this.#dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter(control => control.getClientRects().length > 0);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (!first) return;
        if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }, options);
    }

    disconnectedCallback() {
      if (this.#dialog?.open) this.#dialog.close();
      this.#controller?.abort();
    }

    /** @param {HTMLButtonElement} trigger */
    #openReview(trigger) {
      const card = trigger.closest('[data-community-review]');
      if (!card) return;
      this.#trigger = trigger;

      for (const field of ['name', 'title', 'body', 'product', 'date', 'rating']) {
        const source = card.querySelector(`[data-review-field="${field}"]`);
        const target = this.#dialog.querySelector(`[data-review-detail="${field}"]`);
        target.textContent = source.textContent.trim();
        if (field === 'date') target.setAttribute('datetime', source.getAttribute('datetime'));
        if (field === 'rating') target.setAttribute('aria-label', source.getAttribute('aria-label'));
      }

      const image = card.querySelector('[data-review-field="image"]');
      const detailImage = this.#dialog.querySelector('[data-review-detail="image"]');
      detailImage.src = image.src;
      detailImage.alt = image.alt;
      this.#dialog.querySelector('[data-review-detail="verified"]').hidden = !card.querySelector('[data-review-field="verified"]');
      this.#dialog.dataset.reviewId = card.dataset.reviewId;
      this.#dialog.showModal();
    }
  }

  customElements.define('rm-community-reviews', RMCommunityReviews);
})();
